
import { defineComponent, computed, getCurrentInstance, ref, onMounted, onActivated } from 'vue';
import Tabs from 'vant/lib/tabs';
import Tab from 'vant/lib/tab';
import { getQuery } from '~/common/utils';
import { radarLog } from '~/common/radar';
import { isProduction } from '~/common/env';
import { logForTopTabsSwitchClick, logForTopTabsSwitchShow } from '../../scripts/logger';
import useAppEnvironment from '../../hooks/useAppEnvironment';

enum AITopTabsEnum {
    AI_FOR_YOU = 0,
    FOR_YOU = 1,
    DISCOVER = 2,
    MESSAGES = 3,
}

const TopTabs = defineComponent({
    components: {
        vanTabs: Tabs,
        vanTab: Tab,
    },
    props: {
        currentIndex: {
            type: Number,
            default: 0,
        },
    },

    setup(props) {
        const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };

        // const currentPath = window.location.pathname;
        //     return currentPath?.includes('aichat') ? AITopTabsEnum.AI : AITopTabsEnum.FOR_YOU;

        const activeTab = computed(() => {
            const regexForyou = /^\/(foryou)$|@[\w-]+\/video(\/[\w-]+)?$/;
            const regexAIFriends = /\/(aichat(\/bot\/[\w-]+)?|aichat)$|@[\w-]+\/video(\/[\w-]+)?$/;
            const regexDiscover = /^\/((aichat\/discover?)$|@[\w-]+\/video(\/[\w-]+)?)$/;
            const regexMessages = /^\/((aichat\/inbox?)$|@[\w-]+\/video(\/[\w-]+)?)$/;
            const currentPath = proxy?.$route?.path;
            if (regexForyou.test(currentPath)) {
                return AITopTabsEnum.FOR_YOU;
            }
            if (regexAIFriends.test(currentPath)) {
                return AITopTabsEnum.AI_FOR_YOU;
            }
            if (regexDiscover.test(currentPath)) {
                return AITopTabsEnum.DISCOVER;
            }
            if (regexMessages.test(currentPath)) {
                return AITopTabsEnum.MESSAGES;
            }
            return AITopTabsEnum.FOR_YOU;
        });

        const active = ref(activeTab.value === AITopTabsEnum.AI_FOR_YOU ? 0 : 1);

        const isAIchat = computed(() => {
            return (
                activeTab.value === AITopTabsEnum.AI_FOR_YOU ||
                activeTab.value === AITopTabsEnum.DISCOVER ||
                activeTab.value === AITopTabsEnum.MESSAGES
            );
        });

        const { statusHT } = useAppEnvironment();

        // titles
        const titleForAIForyou = computed(() => {
            const key = proxy?.$store?.state?.startup?.changetab;
            if (isAIchat.value) {
                return proxy.$root.$t('k_1310875');
            }
            return proxy.$root.$t(key) || 'AI Friends';
        });
        const titleForVideoForyou = computed(() => {
            return proxy.$root.$t('k_1310875') || 'For You';
        });
        const titleForAIDiscover = computed(() => {
            return proxy.$root.$t('k_1310876') || 'Discover';
        });
        const titleForAIMessges = computed(() => {
            return 'Messages';
        });
        const onClick = (index: number, name: string, title: string) => {
            const query = getQuery();
            if (name === titleForAIForyou.value) {
                if (activeTab.value === AITopTabsEnum.FOR_YOU) {
                    const currentUrl = new URL(window.location.href);
                    currentUrl.pathname = '/aichat';
                    if (isProduction) {
                        currentUrl.host = 'www.weeeye.com';
                    }
                    window.open(currentUrl.toString());
                    setTimeout(() => {
                        active.value = 1;
                    }, 100);
                } else {
                    logForTopTabsSwitchClick('ai_friends');
                    proxy.$router.push({ path: '/aichat', query: { ...query } });
                }
            } else if (name === titleForVideoForyou.value) {
                proxy.$router.push({ path: '/foryou', query: { ...query } });
            } else if (name === titleForAIDiscover.value) {
                logForTopTabsSwitchClick('discovers');
                proxy.$router.push({ path: '/aichat/discover', query: { ...query } });
            } else {
                logForTopTabsSwitchClick('messages');
                proxy.$router.push({ path: '/aichat/inbox', query: { ...query } });
            }
            radarLog({
                name: 'PWA_WEB_CLICK_TOP_BAR',
                event_type: 'click',
                category: 'KWAI_SHARE',
                message: `index: ${index}`,
                src: window.location.href,
            });
        };
        onMounted(() => {
            setTimeout(() => {
                if (activeTab.value === AITopTabsEnum.AI_FOR_YOU || activeTab.value === AITopTabsEnum.DISCOVER) {
                    logForTopTabsSwitchShow(activeTab.value === AITopTabsEnum.AI_FOR_YOU ? 'ai_friends' : 'discovers');
                }
            }, 2000);
        });
        onActivated(() => {});
        return {
            onClick,

            active,
            titleForAIForyou,
            titleForVideoForyou,
            titleForAIDiscover,
            isAIchat,
            activeTab,
            titleForAIMessges,
            statusHT,
        };
    },
});

export default TopTabs;
